import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Blog } from 'src/app/shared/models/blog';

@Component({
  selector: 'app-blog-card',
  templateUrl: './blog-card.component.html',
  styleUrls: ['./blog-card.component.scss']
})
export class BlogCardComponent implements OnInit {
  @Input() blog: Blog
  @Input() limit: number
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.blog && this.blog.body && this.blog.body !== '') {
      this.blog.body = this.formatContent(this.blog.body)
    }
  }

  formatContent(body: string) {
    return `${body.substr(0, this.limit)}...`
  }

}
